import { CatalogResource } from '../types/resourceCatalog';
import { WPPost } from '../types/wordpress';
import { Hub } from '../types/hub';
import { Program } from '../types/program';

export function placedDocumentIds(hubs: Hub[], programs: Program[]): Set<number> {
  const ids = new Set<number>();
  for (const hub of hubs) {
    for (const resource of hub.resources) ids.add(resource.wpPostId);
  }
  for (const program of programs) {
    for (const highlight of program.highlights ?? []) ids.add(highlight.wpPostId);
    for (const hub of program.hubs ?? []) {
      for (const resource of hub.resources ?? []) ids.add(resource.wpPostId);
    }
  }
  return ids;
}

export function rankCatalogResources(
  resources: CatalogResource[],
  wpById: Map<number, WPPost>,
  placedIds: Set<number>,
  reportCategoryId: number
): { documents: CatalogResource[]; news: CatalogResource[] } {
  const placed: CatalogResource[] = [];
  const other: CatalogResource[] = [];
  const news: CatalogResource[] = [];
  for (const resource of resources) {
    const wp = wpById.get(resource.wpId);
    if (wp?.parent) continue;
    if (wp?.categories?.includes(reportCategoryId)) {
      news.push(resource);
      continue;
    }
    if (placedIds.has(resource.wpId)) placed.push(resource);
    else other.push(resource);
  }
  return { documents: [...placed, ...other], news };
}
